import { ChangeEventHandler } from 'react';

import './ContextMenuSelect.scss';

interface ContextMenuSelectProps {
  ariaLabel: string;
  texts: string[];
  values: (string | number)[];
  value: string | number;
  onChange: ChangeEventHandler<HTMLSelectElement>;
}

const defaultProps = {
  ariaLabel: undefined,
  texts: [],
  values: [],
  value: null,
  onChange() {},
};

function ContextMenuSelect({ ariaLabel, texts, values, value, onChange }: ContextMenuSelectProps) {
  return (
    <div className="ContextMenuSelect">
      <select
        aria-label={ariaLabel}
        className="ContextMenuSelect__select"
        value={value}
        onChange={onChange}
      >
        {values.map((nowValue, index) => (
          <option key={nowValue} value={nowValue}>
            {texts[index]}
          </option>
        ))}
      </select>
    </div>
  );
}

ContextMenuSelect.defaultProps = defaultProps;

export default ContextMenuSelect;
